import React from 'react'
import useDateFormat from '@ui/hooks/useDateFormat'
import { useTicker } from '@ui/hooks/useTicker'
import { Text } from 'react-native'

interface Props {
    options?: Intl.DateTimeFormatOptions
    locale?: string
}

export default function Clock({ options, locale = 'de' }: Props) {
    useTicker()

    const format = useDateFormat(options, locale)

    return <Text>{format(new Date())}</Text>
}
